import React, { useEffect, useLayoutEffect, useState } from "react";
import {  CloseOutlined } from '@mui/icons-material';


import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
    maxWidth: 500,
    borderRadius: 20,
  },
  select: {
    backgroundColor: "#fff",
    "& .MuiSelect-select": {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "8px",
      minHeight: "40px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  outlinedInput: {
    backgroundColor: "#fff",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  chip: {
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "16px",
    margin: "2px",
    color: "#333",
    "& .MuiChip-label": {
      color: "#333",
    },
    "& .MuiChip-deleteIcon": {
      color: "#1976d2",
      "&:hover": {
        color: "#d32f2f",
      },
    },
  },
  menuItem: {
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#e3f2fd",
    },
    "&.Mui-selected": {
      backgroundColor: "#bbdefb",
      "&:hover": {
        backgroundColor: "#90caf9",
      },
    },
  },
  selectAllItem: {
    
    borderBottom: "1px solid #e0e0e0",
    paddingTop: "8px",
    paddingBottom: "8px",
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    zIndex: 1,
  },
  checkbox: {
    color: "#1976d2",
    "&.Mui-checked": {
      color: "#1976d2",
    },
  },
  typography: {
    fontSize: "0.875rem",
  },
  chipBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
    padding: "4px",
    // maxHeight: "120px",
    // overflowY: "auto",
  },
  dropdownPaper: {
    backgroundColor: "#fff",
    "& .MuiMenu-list": {
      backgroundColor: "#fff",
      padding: 0,
      borderRadius: "12px",
      overflow: "auto",
      maxHeight: "300px",
    },
    boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
    borderRadius: "12px",
  },
  menuList: {
    maxHeight: "300px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "4px",
      "&:hover": {
        background: "#555",
      },
    },
  },
  icon: {
    color: "#757575",
  },
  divider: {
    margin: 0,
    position: "sticky",
    top: "40px",
    backgroundColor: "#e0e0e0",
    zIndex: 1,
  },
  noDataMessage: {
    padding: "16px",
    textAlign: "center",
    color: "#666",
    fontStyle: "italic",
  },
}));

const MultiCheckboxDropdown = ({
  data = [],
  onChange,
  selectedVocabData = [],
}) => {
  const classes = useStyles();
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    // Convert initially selected words to IDs
    const initialIds = data
      .filter((item) => selectedVocabData.includes(item.data.word))
      .map((item) => item.id);
    setSelectedIds(initialIds);
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    const selected = Array.isArray(value) ? value : [];
    setSelectedIds(selected);
    // Convert IDs to words before calling onChange
    const selectedWords = selected.map((id) => {
      const item = data.find((item) => item.id === id);
      return item ? item.data.word : "";
    });
    onChange(selectedWords);
  };

  const handleDelete = (event, idToDelete) => {
    event.stopPropagation();
    const newSelected = selectedIds.filter((id) => id !== idToDelete);
    setSelectedIds(newSelected);
    // Convert IDs to words before calling onChange
    const selectedWords = newSelected.map((id) => {
      const item = data.find((item) => item.id === id);
      return item ? item.data.word : "";
    });
    onChange(selectedWords);
  };

  const handleSelectAll = (event) => {
    event.stopPropagation();
    const allIds = data.map((item) => item.id);
    const newSelected = selectedIds.length === data.length ? [] : allIds;
    setSelectedIds(newSelected);
    // Convert IDs to words before calling onChange
    const selectedWords = newSelected.map((id) => {
      const item = data.find((item) => item.id === id);
      return item ? item.data.word : "";
    });
    onChange(selectedWords);
  };

  const handleMenuItemClick = (event, clickedId) => {
    event.stopPropagation();
    const currentIndex = selectedIds.indexOf(clickedId);
    let newSelected = [...selectedIds];

    if (currentIndex === -1) {
      newSelected.push(clickedId);
    } else {
      newSelected.splice(currentIndex, 1);
    }

    setSelectedIds(newSelected);

    const selectedWords = newSelected.map((id) => {
      const item = data.find((item) => item.id === id);
      return item ? item.data.word : "";
    });
    onChange(selectedWords);
  };

  const getWordById = (id) => {
    const item = data.find((item) => item.id === id);
    return item ? item.data.word : "";
  };

  const renderDropdownContent = () => {
    if (!data.length) {
      return (
        <MenuItem disabled className={classes.noDataMessage}>
          No vocabulary available
        </MenuItem>
      );
    }

    return (
      <>
        <MenuItem
          className={`${classes.menuItem} ${classes.selectAllItem}`}
          onClick={handleSelectAll}
        >
          <Checkbox
            checked={data.length > 0 && selectedIds.length === data.length}
            indeterminate={
              selectedIds.length > 0 && selectedIds.length < data.length
            }
            className={classes.checkbox}
          />
          <ListItemText primary="Select All" />
        </MenuItem>
        {/* <Divider className={classes.divider} /> */}
        {data.map((item) => (
          <MenuItem
            key={item.id}
            value={item.id}
            onClick={(event) => handleMenuItemClick(event, item.id)}
            className={classes.menuItem}
          >
            <Checkbox
              checked={selectedIds?.includes(item?.id)}
              className={classes.checkbox}
            />
            <ListItemText
              primary={item?.data?.word || ""}
              secondary={
                <Typography
                  variant="body2"
                  color="textSecondary"
                  className={classes.typography}
                >
                  {item?.data?.definition ? item?.data?.definition?.substring(0, 60) : ""}...
                </Typography>
              }
            />
          </MenuItem>
        ))}
      </>
    );
  };

  return (
    <FormControl className={classes.formControl}>
      <Select
        multiple
        value={selectedIds}
        onChange={handleChange}
        displayEmpty
        placeholder="Select a word from vocabulary"
        className={classes.select}
        input={<OutlinedInput className={classes.outlinedInput} />}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <span style={{ color: "#757575", marginTop: "10px" }}>
                Select a word from vocabulary
              </span>
            );
          }
          return (
            <Box
            
              className={classes.chipBox}
            >
              {selected.map((id) => (
                <Chip
                  key={id}
                  label={getWordById(id)}
                  className={classes.chip}
                  onDelete={(e) => handleDelete(e, id)}
                  deleteIcon={
                    <CloseOutlined
                      onMouseDown={(event) => {
                        event.stopPropagation();
                      }}
                      style={{ fontSize: 20 }}
                    />
                  }
                />
              ))}
            </Box>
          );
        }}
        // IconComponent={(props) => (
        //   <ExpandMoreOutlined {...props} className={classes.icon} />
        // )}
        MenuProps={{
          PaperProps: {
            className: classes.dropdownPaper,
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
      >
        {renderDropdownContent()}
      </Select>
    </FormControl>
  );
};

export default MultiCheckboxDropdown;